import BaseViewStore from './BaseViewStore';
import {
	getErrorMessage,
	translate,
	isSeller,
	isWarehouse,
	isSuperAdminOrganization,
	displayChatWidget,
} from 'core/utils';
import { SyncService } from 'common/data';
import { observable, action, makeObservable, runInAction } from 'mobx';
import { ChannelService, OrderService } from 'common/data';
import { localStorageHandler } from 'core/services';
import { sourceOfChange } from 'common/constants';
import LoginStore from 'modules/membership/stores/LoginStore';
import _ from 'lodash';
import BaasicDropdownViewStore from 'common/stores/BaasicDropdownViewStore';
import { ApplicationStore } from 'platform/application/stores';
import { ModalParams } from 'core/models';

class MainViewStore extends BaseViewStore {
	@observable isSyncAllowed = false;
	@observable isModeAllowed = false;
	@observable isCollapsed = false;
	@observable loadingChannelId;
	@observable syncAllInProgress = false;
	@observable syncInProgress = false;
	@observable profileMenuOpen = false;
	@observable syncMenuOpen = false;
	@observable modeMenuOpen = false;
	@observable actionMenuOpen = false;
	@observable unlinkedOrderLines = 0;
	@observable event = window.addEventListener('resize', this.onSizeChange);
	@observable options = [];
	@observable channels = [];
	@observable modes = [];
	@observable displaySellerDropdown = false;
	@observable selectedConfirmModal;
	@observable selectedModal;
	@observable nestedModal;
	headerComponentTypes = {
		searchComponent: 1,
		miscComponent: 2,
		buttonComponent: 3,
	};
	@observable headerComponents = [
		{
			type: this.headerComponentTypes.searchComponent,
			active: false,
			queryUtility: null,
		},
		{
			type: this.headerComponentTypes.buttonComponent,
			active: false,
			buttonProps: null,
		},
		{
			type: this.headerComponentTypes.miscComponent,
			active: false,
			componentData: null,
		},
	];
	loginStore = null;
	channelService = null;
	syncService = null;
	orderService = null;
	// The list view store the header seller dropdown currently filters. Held as a
	// direct reference, not a name: class names do not survive the bundler.
	sellerChildViewStore = null;
	setInterval = true;

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.channelService = new ChannelService(rootStore.app.baasic.apiClient);
		this.syncService = new SyncService(rootStore.app.baasic.apiClient);
		this.orderService = new OrderService(rootStore.app.baasic.apiClient);
		this.loginStore = new LoginStore(rootStore);
		this.applicationStore = new ApplicationStore(rootStore);
		displayChatWidget();
	}



	@action.bound onSizeChange() {
		window.screen.width <= 1024 || window.innerWidth < 1024 ? (this.isCollapsed = true) : (this.isCollapsed = false);
		localStorageHandler.set('is-menu-collapsed', this.isCollapsed);
	}

	@action.bound toggleCollapse() {
		this.isCollapsed = !this.isCollapsed;
		localStorageHandler.set('is-menu-collapsed', this.isCollapsed);
	}

	@action.bound headerSetSearch(queryUtility = null) {
		_.find(this.headerComponents, (val, key, col) => {
			if (val.type === this.headerComponentTypes.searchComponent) {
				col[key].queryUtility = queryUtility;
				if (col[key].queryUtility) col[key].active = true;
				else col[key].active = false;
				return true;
			}
			return false;
		});
		this.isCollapsed = localStorageHandler.get('is-menu-collapsed');
	}

	@action.bound headerSetModes(modes) {
		if (modes) {
			this.modes = modes;
		} else {
			this.modes = [];
		}
	}

	@action.bound headerSetButton(buttonProps = {}) {
		this.isSyncAllowed = isSeller(this.rootStore) || isSuperAdminOrganization(this.rootStore);
		this.isModeAllowed = isWarehouse(this.rootStore);
		_.find(this.headerComponents, (val, key, col) => {
			if (val.type === this.headerComponentTypes.buttonComponent) {
				col[key].buttonProps = buttonProps;
				if (col[key].buttonProps.buttons) col[key].active = true;
				else col[key].active = false;
				return true;
			}
			return false;
		});
	}

	@action.bound headerSetComponent(component = {}) {
		_.find(this.headerComponents, (val, key, col) => {
			if (val.type === this.headerComponentTypes.miscComponent) {
				col[key].componentData = component;
				if (col[key].componentData.props) col[key].active = true;
				else col[key].active = false;
				return true;
			}
			return false;
		});
	}

	@action.bound toggleActionMenu() {
		this.actionMenuOpen = !this.actionMenuOpen;
	}

	@action.bound setActionMenu(visible) {
		this.actionMenuOpen = visible;
	}

	@action.bound toggleProfileMenu() {
		this.profileMenuOpen = !this.profileMenuOpen;
	}

	@action.bound toggleModeMenu() {
		this.modeMenuOpen = !this.modeMenuOpen;
	}

	@action.bound setProfileMenu(visible) {
		this.profileMenuOpen = visible;
	}

	@action.bound setModeMenu(visible) {
		if (this.modeMenuOpen) {
			this.modeMenuOpen = visible;
		}
	}

	@action.bound toggleSyncMenu() {
		if (!this.syncAllInProgress && !this.syncInProgress) {
			this.syncMenuOpen = !this.syncMenuOpen;
			if (this.syncMenuOpen) {
				this.getChannels();
			}
		}
	}

	@action.bound async countUnlinkedOrderLines() {
		let response = await this.orderService.getUnlinkedOrderLines({ getUnlinkedOrderLines: true });
		runInAction(() => {
			if (response.data == 0) {
				this.unlinkedOrderLines = null;
			} else {
				this.unlinkedOrderLines = response.data;
			}
		});
	}

	@action.bound getChannels() {
		var a = this.channelService.find({ page: 1, rpp: 50, sort: 'name', embed: ['channelType'] });
		a.then(v => {
			this.channels = _.sortBy(v.data.item, ['name']);
		});
	}

	@action async syncChannelOrders(channel) {
		this.loadingChannelId = channel.id;
		this.syncInProgress = true;
		try {
			const {
				data: { total, created, updated, canceled },
			} = await this.syncService.syncByChannelAsync(channel.id, sourceOfChange.syncSingleChannelOrdersMainMenu);
			if (created == 0) {
				this.rootStore.notificationStore.success([
					'CHANNELSYNCNONEWENTRIES',
					{ name: channel.name, updated, canceled },
				]);
			} else {
				this.rootStore.notificationStore.success([
					'CHANNELSYNCSUCCESS',
					{ name: channel.name, total, created, updated, failed: total - (updated + created), canceled },
				]);
			}
		} catch (err) {
			this.syncInProgress = false;
			this.loadingChannelId = null;
			let message = getErrorMessage(err, { name: channel.name });
			const parsedMessage = translate(message);
			if (parsedMessage.startsWith('BAASIC')) {
				message = ['CHANNELSYNCERROR.DEFAULT', { name: channel.name }];
			}
			if (message[0] === parsedMessage) {
				message = ['CHANNELSYNCERROR.DEFAULTWITHORIGINAL', { name: channel.name, originalMessage: parsedMessage }];
			}
			this.rootStore.notificationStore.error(message);
		}
		this.getChannels();
		this.checkForReload();
		this.loadingChannelId = null;
		this.syncInProgress = false;
	}

	@action.bound async checkForReload() {
		if (this.rootStore.channelListViewStore != null) {
			await this.rootStore.channelListViewStore.reloadChannels();
		}
	}

	@action.bound async syncAllOrders() {
		this.syncAllInProgress = true;
		this.syncInProgress = true;
		this.syncService = new SyncService(this.rootStore.app.baasic.apiClient);
		try {
			const { data } = await this.syncService.syncAsync(sourceOfChange.syncAllChannelOrders);
			const [failedSyncs, successfulSyncs] = _.partition(data, _.property('message'));
			if (_.isEmpty(failedSyncs)) {
				this.rootStore.notificationStore.success(['CHANNELSSYNCSUCCESS']);
			} else {
				this.rootStore.notificationStore.error([
					'CHANNELSYNCERROR.MULTIPLE',
					{ failCount: _.size(failedSyncs), successCount: _.size(successfulSyncs) },
				]);
			}
		} catch (err) {
			this.syncInProgress = false;
			this.syncAllInProggres = false;
			this.rootStore.notificationStore.error(['CHANNELSSYNCERROR']);
		}
		this.getChannels();
		this.checkForReload();
		this.syncAllInProgress = false;
		this.syncInProgress = false;
	}

	@action.bound setSyncMenu(visible) {
		this.syncMenuOpen = visible;
	}

	@action.bound
	onSellerChange = async () => {
		let childViewStore = this.sellerChildViewStore;

		if (_.get(childViewStore, 'queryUtility')) {
			await this.applySeller(childViewStore, _.get(this.sellerDropdownStore, 'value.value'));
			childViewStore.queryUtility._reloadCollection();
		} else if (_.get(childViewStore, 'reloadSellerCallback')) {
			await childViewStore.reloadSellerCallback(this.sellerDropdownStore.value);
		}
	};

	@action.bound
	handleSellerForChildViewStore = async (childViewStore, displaySellerDropdown = true) => {
		if (!this.sellerDropdownStore) await this.initializeSellerDropdown();
		else this.sellerDropdownStore.setSelectedValue();

		this.setDisplaySellerDropdown(displaySellerDropdown);
		this.setSellerChildViewStore(childViewStore);

		await this.applySeller(childViewStore, _.get(this.sellerDropdownStore.value, 'value'));
		if (childViewStore.reloadSellerCallback) {
			await childViewStore.reloadSellerCallback(this.sellerDropdownStore.value);
		}
	};

	@action.bound
	setDisplaySellerDropdown = value => {
		this.displaySellerDropdown = value;
	};

	@action.bound
	setSellerChildViewStore = value => {
		this.sellerChildViewStore = value;
	};

	@action.bound
	applySeller = async (childViewStore, sellerId) => {
		if (childViewStore.queryUtility != null) {
			childViewStore.queryUtility.filter.sellerIds = sellerId ? [sellerId] : [];
		}
	};

	@action.bound
	initializeSellerDropdown = async () => {
		this.sellerDropdownStore = new BaasicDropdownViewStore();
		await this.sellerDropdownStore.initialize({
			store: new ApplicationStore(this.rootStore),
			itemTemplate: {
				value: 'id',
				label: 'applicationTitle',
			},
			filterProperties: {
				sellerOnly: true,
				embed: ['organizationType'],
			},
			localStorageHandlerKey: 'selectedSeller',
			onChangeCallback: this.onSellerChange,
		});
	};

	submitTicketModal = new ModalParams();
}

export default MainViewStore;
